/**
 * @module Shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[tmoClickOutside]',
})
export class ClickOutsideDirective {
  @Output()
  public tmoClickOutside: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.elRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.tmoClickOutside.emit(event);
    }
  }

  constructor(private elRef: ElementRef) {}
}
